import { ComposicaoRda } from './composicao-rda.model';
import { Regiao } from './regiao.model';
import { TipoValorCreditoFinanceiro } from './tipo-valor-credito-financeiro.model';
import { CartaCreditoFinanceiroGerada } from './carta-credito-financeiro-gerada.model';

export class ValorCartaCreditoFinanceiro {

    id: number;
    composicaoRda: ComposicaoRda;
    regiao: Regiao;
    tipoValorCredito: TipoValorCreditoFinanceiro;
    valor: number;
    valorCalculado: boolean;
    cartaCreditoGerada: CartaCreditoFinanceiroGerada;

  constructor(init?: Partial<ValorCartaCreditoFinanceiro>) {
    Object.assign(this, init);
  }

}
